<script>
  import pessoaFisicaServico from '../servico';
  import Carregando from '~componentes/Carregando.vue';
  import CabecalhoRelatorio from './CabecalhoRelatorio.vue';
  
  export default {
    components: {
      Carregando, CabecalhoRelatorio
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
        carregando: true,
        titulo: '',
        ano: '',
        anoBase: '',
        valoresIRPF: {
          totalRendimento: 0.00,
          totalPrevidencia: 0.00,
          totalImpostoRetido: 0.00,
          totalDiariaAjudaCusto: 0.00,
          totalBolsaEOutros: 0.00,
        }
      }
    },
    methods: {
      carregar() {
        this.carregando = true;
        
        return pessoaFisicaServico
          .gerarIRPF(this.anoBase)
          .then(dados => { 
            this.valoresIRPF = dados;
          })
          .then(() => {
            this.carregando = false;
          });
      },
      imprimirPagina() {
        window.print();
      },
      voltar() {
        this.$router.push({
          name: 'pessoa-fisica.irpf'
        });
      },
    },
    mounted() {
      this.ano = this.$route.params.ano;
      this.anoBase = this.ano - 1;

      this.titulo = `Declaração de Rendimentos - Ano ${this.ano} (Ano base ${this.anoBase})`;
      this.$root.tituloDaPagina = this.titulo;

      this.$root.botaoAcaoMostrar = false;

      this.carregar();
    },
    computed: {
      cidadeEstadoFundacao() {
        return this.configuracao.cidadeFundacao + ' - ' + this.configuracao.estadoFundacao;
      },
      nomeResponsavel() {
        return this.configuracao.pessoaRespDecRendimento || '';
      },
      dataResponsavel() {
        const data = this.configuracao.dataRespDecRendimento && this.configuracao.dataRespDecRendimento !== '1900-01-01T00:00:00'
          ? new Date(this.configuracao.dataRespDecRendimento)
          : new Date();

        return data.toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      },
      dataAtual() {
        return new Date().toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      },
    },
  }
</script>

<template>
  <div>
    <carregando v-if="carregando"></carregando>
    <div class="ibox float-e-margins" v-if="!carregando">
      <div class="ibox-content">
        <cabecalho-relatorio :titulo="titulo"
                             borda="">
        </cabecalho-relatorio>

        <div class="padding-5"></div>

        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <h3><b>
              COMPROVANTE DE SERVIÇOS PRESTADOS PAGOS E DE RETENÇÃO <br />
              NA FONTE DE IMPOSTOS FEDERAIS A PESSOA FÍSICA
            </b></h3>
            <div class="hr-line-dashed margin-top-5"></div>

            <div>
              <h4><b>1. FONTE PAGADORA PESSOA FÍSICA</b></h4>

              <div class="row">
                <dl class="col-xs-9">
                  <dt>CNPJ / CPF</dt>
                  <dd>{{ configuracao.cnpjFundacao || '---'}}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>Telefone</dt>
                  <dd>{{ configuracao.telefoneFundacao1 || '---'}}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-12">
                  <dt>Razão Social / Nome</dt>
                  <dd>{{ configuracao.nomeFundacao || '---'}}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-9">
                  <dt>Endereço</dt>
                  <dd>{{ configuracao.enderecoFundacao || '---'}}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>Cidade</dt>
                  <dd>{{ cidadeEstadoFundacao || '---'}}</dd>
                </dl>
              </div>
            </div>

            <div class="hr-line-dashed margin-top-5"></div>

            <div>
              <h4><b>2. PESSOA FISÍCA BENEFICIADA DOS RENDIMENTOS</b></h4>

              <div class="row">
                <dl class="col-xs-2">
                  <dt>Ano calendário</dt>
                  <dd>{{ ano || '---'}}</dd>
                </dl>

                <dl class="col-xs-2">
                  <dt>Ano base</dt>
                  <dd>{{ anoBase || '---'}}</dd>
                </dl>

                <dl class="col-xs-3">
                  <dt>CPF</dt>
                  <dd>{{ usuario.documento || '---'}}</dd>
                </dl>

                <dl class="col-xs-5">
                  <dt>Nome</dt>
                  <dd>{{ usuario.nome || '---'}}</dd>
                </dl>
              </div>
            </div>

            <div class="hr-line-dashed margin-top-5"></div>

            <div>
              <div class="row">
                <div class="col-sm-9">
                  <h4><b>3. RENDIMENTOS TRIBUTÁVEIS, DEDUÇÕES E IMPOSTO RETIDO NA FONTE</b></h4>
                </div>
                <div class="col-sm-3 text-right">
                  <h4><b>EM R$</b></h4>
                </div>
              </div>
              <div class="row">
                <dl class="col-xs-9">
                  <dd>01. Total dos rendimentos (inclusive férias)</dd>
                </dl>
                <dl class="col-xs-3 text-right">
                  <dt>{{ valoresIRPF.totalRendimento | formatarNumero }}</dt>
                </dl>
              </div>
              <div class="row">
                <dl class="col-xs-9">
                  <dd>02. Contribuição previdenciária oficial</dd>
                </dl>
                <dl class="col-xs-3 text-right">
                  <dt>{{ valoresIRPF.totalPrevidencia | formatarNumero }}</dt>
                </dl>
              </div>
              <div class="row">
                <dl class="col-xs-9">
                  <dd>03. Contribuição à previdência privada</dd>
                </dl>
                <dl class="col-xs-3 text-right">
                  <dt>0,00</dt>
                </dl>
              </div>
              <div class="row">
                <dl class="col-xs-9">
                  <dd>04. Pensão o judicial (informar beneficiário no campo 07)</dd>
                </dl>
                <dl class="col-xs-3 text-right">
                  <dt>{{ valoresIRPF.totalPensaoAlimenticia | formatarNumero }}</dt>
                </dl>
              </div>
              <div class="row">
                <dl class="col-xs-9">
                  <dd>05. Imposto retido na fonte</dd>
                </dl>
                <dl class="col-xs-3 text-right">
                  <dt>{{ valoresIRPF.totalImpostoRetido | formatarNumero }}</dt>
                </dl>
              </div>
            </div>

            <div class="hr-line-dashed margin-top-5"></div>

            <div>
              <div class="row">
                <div class="col-sm-9">
                  <h4><b>4. RENDIMENTOS ISENTOS E NÃO TRIBUTÁVEIS</b></h4>
                </div>
                <div class="col-sm-3 text-right">
                  <h4><b>EM R$</b></h4>
                </div>
              </div>
              <div class="row">
                <dl class="col-xs-9">
                  <dd>01. Salário família</dd>
                </dl>
                <dl class="col-xs-3 text-right">
                  <dt>0,00</dt>
                </dl>
              </div>
              <div class="row">
                <dl class="col-xs-9">
                  <dd>02. Parte dos proventos de aposentadoria, reserva, reforma e pensão (65 anos ou mais)</dd>
                </dl>
                <dl class="col-xs-3 text-right">
                  <dt>0,00</dt>
                </dl>
              </div>
              <div class="row">
                <dl class="col-xs-9">
                  <dd>03. Diárias e ajudas de custo</dd>
                </dl>
                <dl class="col-xs-3 text-right">
                  <dt>{{ valoresIRPF.totalDiariaAjudaCusto | formatarNumero }}</dt>
                </dl>
              </div>
              <div class="row">
                <dl class="col-xs-9">
                  <dd>04. Proventos de pensão, aposentadoria ou reforma por moléstia grave ou por invalidez permanente</dd>
                </dl>
                <dl class="col-xs-3 text-right">
                  <dt>0,00</dt>
                </dl>
              </div>
              <div class="row">
                <dl class="col-xs-9">
                  <dd>05. Lucros e dividendo de 1996 pago por pessoa jurídica (lucro real presumido ou arbitrado)</dd>
                </dl>
                <dl class="col-xs-3 text-right">
                  <dt>0,00</dt>
                </dl>
              </div>
              <div class="row">
                <dl class="col-xs-9">
                  <dd>06. Outros (bolsa acadêmica/Lei 8959/1994)</dd>
                </dl>
                <dl class="col-xs-3 text-right">
                  <dt>{{ valoresIRPF.totalBolsaEOutros | formatarNumero }}</dt>
                </dl>
              </div>
            </div>

            <div class="hr-line-dashed margin-top-5"></div>

            <div>
              <div class="row">
                <div class="col-sm-9">
                  <h4><b>5. RENDIMENTOS SUJEITOS À TRIBUTAÇÃO EXCLUSIVA (RENDIMENTO LÍQUIDO)</b></h4>
                </div>
                <div class="col-sm-3 text-right">
                  <h4><b>EM R$</b></h4>
                </div>
              </div>
              <div class="row">
                <dl class="col-xs-9">
                  <dd>01. Décimo terceiro salário</dd>
                </dl>
                <dl class="col-xs-3 text-right">
                  <dt>0,00</dt>
                </dl>
              </div>
              <div class="row">
                <dl class="col-xs-9">
                  <dd>02. Outros</dd>
                </dl>
                <dl class="col-xs-3 text-right">
                  <dt>0,00</dt>
                </dl>
              </div>
            </div>

            <div class="hr-line-dashed margin-top-5"></div>

            <div>
              <div class="row">
                <div class="col-sm-9">
                  <h4><b>6. INFORMAÇÕES COMPLEMENTARES</b></h4>
                </div>
                <div class="col-sm-3 text-right">
                  <h4><b>EM R$</b></h4>
                </div>
              </div>
              <div class="row">
                <dl class="col-xs-9">
                  <dd>Nenhuma informação complementar</dd>
                </dl>
                <dl class="col-xs-3 text-right">
                  <dt>0,00</dt>
                </dl>
              </div>
            </div>

            <div class="hr-line-dashed margin-top-5"></div>

            <div>
              <div class="row">
                <div class="col-sm-12">
                  <h4><b>7. RESPONSÁVEL PELAS INFORMAÇÕES</b></h4>
                </div>
              </div>
              <div class="row">
                <dl class="col-xs-5">
                  <dt>Nome</dt>
                  <dd>{{ nomeResponsavel }}</dd>
                </dl>
                <dl class="col-xs-3">
                  <dt>Data</dt>
                  <dd>{{ dataResponsavel }}</dd>
                </dl>
                <dl class="col-xs-4">
                  <dt>Assinatura</dt>
                  <dd></dd>
                </dl>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <span><i>Aprovado pelo IN/SRF Nº 063, de 26 de novembro de 1996</i></span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="row hidden-print" v-show="!carregando">
        <div class="col-xs-12 margin-top-10">
          <div class="form-group">
            <button class="btn btn-primary" @click="imprimirPagina">
              <i class="fa fa-file-pdf-o"></i> PDF
            </button>
            <button class="btn btn-secundary"
                    @click="voltar">
              <i class="fa fa-arrow-left"></i> Voltar
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/pessoa-fisica/componentes/GerarIRPF.vue